import { StripeV2SubscriptionPrice } from '@/services/stripe/dto';

const STORAGE_KEY = 'purchased_plan';

export const savePurchasedPlan = (plan: StripeV2SubscriptionPrice): void => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(plan));
  } catch (error) {
    console.error('Failed to save purchased plan to localStorage:', error);
  }
};

export const getPurchasedPlan = (): StripeV2SubscriptionPrice | null => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) {
      return null;
    }
    return JSON.parse(stored) as StripeV2SubscriptionPrice;
  } catch (error) {
    console.error('Failed to get purchased plan from localStorage:', error);
    return null;
  }
};

export const clearPurchasedPlan = (): void => {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (error) {
    console.error('Failed to clear purchased plan from localStorage:', error);
  }
};
